import { createContext, useEffect, useState } from "react";
import api from "../service/api";

export const PlanContext = createContext();

export function PlanProvider({ children }) {
  const [plans, setPlans] = useState([]);
  const [insertPlanLoading, setInsertPlanLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const addPlan = async (payload) => {
    setInsertPlanLoading(true);
    try {
      await api.post("/plans", payload);
      return true;
    } catch (e) {
      const msg = e?.response?.data?.message || e.message;
      console.log("Erro ao salvar plano:", msg);
      return { error: Array.isArray(msg) ? msg.join("\n") : msg };
    } finally {
      setInsertPlanLoading(false);
    }
  };

  const deletePlan = async (id) => {
    setDeleteLoading(true);
    try {
      await api.delete(`/plans/${id}`);
      return true;
    } catch (e) {
      const msg = e?.response?.data?.message || e.message;
      console.log("Erro ao deletar plano:", msg);
      return { error: Array.isArray(msg) ? msg.join("\n") : msg };
    } finally {
      setDeleteLoading(false);
    }
  };

  const editPlan = async (id, payload) => {
    setInsertPlanLoading(true);
    try {
      await api.patch(`/plans/${id}`, payload);
      return true;
    } catch (e) {
      const msg = e?.response?.data?.message || e.message;
      console.log("Erro ao editar plano:", msg);
      return { error: Array.isArray(msg) ? msg.join("\n") : msg };
    } finally {
      setInsertPlanLoading(false);
    }
  };

  const getPlans = async () => {
    api
      .get("/plans")
      .then((response) => {
        console.log("Plans API Response:", response.data);
        const data = Array.isArray(response.data.data) ? response.data.data.sort((a, b) => a.id > b.id) : [];
        setPlans(data)
      })
      .catch(e => console.log("Erro ao buscar planos:", e.message));
  };

  useEffect(() => {
    if (!insertPlanLoading || !deleteLoading) getPlans();
  }, [insertPlanLoading, deleteLoading]);

  return (
    <PlanContext.Provider
      value={{
        plans,
        insertPlanLoading,
        setInsertPlanLoading,
        deleteLoading,
        addPlan,
        deletePlan,
        editPlan,
        getPlans,
      }}
    >
      {children}
    </PlanContext.Provider>
  );
}
